export enum FooterTranslationElementId {
  copyright_notice_message = 'footer_copyright_notice_message',
  timezone_notice_message = 'footer_timezone_notice_message'
}
